<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/productapproval' }">产品批文</el-breadcrumb-item>
                <el-breadcrumb-item>产品批文{{type == '1' ? '编辑' : '新增',}}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submitDetailsData('ruleDetailsForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleDetailsForm" :label-position="labelPosition" class="details_temp2023">
                        <el-form-item label="code：" prop="code">
                            <el-input v-model="ruleForm.code" size="mini" placeholder="请输入代码" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="批准文号：" prop="licence_number">
                            <el-input v-model="ruleForm.licence_number" size="mini" placeholder="请输入批准文号" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="产品通用名：" prop="product_common_name">
                            <el-input
                                v-model="ruleForm.product_common_name"
                                size="mini"
                                placeholder="请输入产品通用名"
                                clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="产品剂型：" prop="product_formulation">
                            <el-input size="mini" v-model="ruleForm.product_formulation" placeholder="请输入产品剂型" clearable />
                        </el-form-item>
                        <el-form-item label="含量规格：" prop="content_spec">
                            <el-input
                                clearable
                                size="mini"
                                v-model="ruleForm.content_spec"
                                type="number"
                                placeholder="请输入含量规格"
                                :min="0"
                            />
                        </el-form-item>
                        <el-form-item label="有效期(月)：" prop="validity_months">
                            <el-input
                                size="mini"
                                v-model="ruleForm.validity_months"
                                placeholder="请输入有效期(月)"
                                :min="0"
                                oninput="this.value=/^-$|^-?[1-9][0-9]*$/.test(this.value)?this.value:''"
                                clearable
                            />
                        </el-form-item>
                        <el-form-item label="含量规格单位：" prop="content_un">
                            <el-input size="mini" v-model="ruleForm.content_un" placeholder="请输入含量规格单位" clearable />
                        </el-form-item>
                        <el-form-item label="有效期(天)：" prop="validity_days">
                            <el-input
                                size="mini"
                                v-model="ruleForm.validity_days"
                                placeholder="请输入有效期(天)"
                                :min="0"
                                oninput="this.value=/^-$|^-?[1-9][0-9]*$/.test(this.value)?this.value:''"
                                clearable
                            />
                        </el-form-item>
                        <el-form-item label="包装规格单位：" prop="dosage_un">
                            <el-input size="mini" v-model="ruleForm.dosage_un" placeholder="请输入包装规格单位" clearable />
                        </el-form-item>
                        <el-form-item label="生产企业：" prop="manufacturer_rid">
                            <el-select
                                style="width: 100%"
                                v-model="ruleForm.manufacturer_name"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="请输入生产企业搜索"
                                :remote-method="remoteMethodParent"
                                :loading="parentLoadingParent"
                                size="mini"
                                clearable
                                @change="parentChange"
                            >
                                <el-option v-for="item in parentOptionsParent" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="治疗领域：" prop="product_therapeutic_area_rids">
                            <el-input size="mini" v-model="ruleForm.product_therapeutic_area_rids" placeholder="请输入治疗领域" clearable />
                        </el-form-item>
                        <el-form-item label="创建人：" prop="created_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.created_by ? ruleForm.created_by : '' }} 
                            </div>
                        </el-form-item>
                        <el-form-item label="上次修改人：" prop="updated_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.updated_by ? ruleForm.updated_by : '' }} 
                            </div>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
export default {
    name: 'productEdit',
    data() {
        return {
            btnLoading: false,
            rid: '',
            title: '', //新增或编辑
            type: '', //1  编辑 2 新增
            activeNames: ['1'],
            parentOptions: [], //主联系人
            parentOptionsParent: [], //上级ID
            parentLoadingParent: false,
            parentlist: [],
            states: [],
            labelPosition: 'right',
            //基本信息内表单验证
            ruleForm: {},
            rules: {
                code: [{ required: true, message: '请输入代码', trigger: 'blur' }],
                product_common_name: [{ required: true, message: '请输入产品通用名', trigger: 'blur' }],
                content_spec: [{ required: true, message: '请输入含量规格', trigger: 'blur' }],
                content_un: [{ required: true, message: '请输入含量规格单位', trigger: 'blur' }],
                dosage_un: [{ required: true, message: '请输入包装规格单位', trigger: 'blur' }]
            },
            btnTitle: ''
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.rid = this.$route.query.id;
    },
    mounted() {
        if (this.type == 1 || this.type == 5) {
            this.getDetails(); //获取详情
        } else {
            this.ruleForm = {};
        }
        this.parentlist = this.states.map((item) => {
            return { value: `${item.rid}`, label: `${item.name}` };
        });
    },
    computed: {
        listSet() {
            return this.states.map((item) => {
                return { value: `${item.rid}`, label: `${item.name}` };
            });
        }
    },
    methods: {
        //生产企业远程搜索方法
        remoteMethodParent(query) {
            if (query !== '') {
                this.parentLoadingParent = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchAccounts(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.states = res.data;
                            setTimeout(() => {
                                this.parentLoadingParent = false;
                                this.parentOptionsParent = this.listSet.filter((item) => {
                                    return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                                });
                            }, 200);
                        } else {
                            this.parentOptionsParent = [];
                        }
                    })
                    .catch((error) => {
                        
                    });
            } else {
                this.parentLoadingParent = false;
                this.parentOptionsParent = [];
            }
        },
        //上级名称联动框改变
        parentChange(value) {
            this.ruleForm.manufacturer_rid = value;
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/productApproval' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .productLicenceDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.ruleForm = res.data;
                    }
                })
                .catch((error) => {
                    
                });
        },
        //提交产品批文 信息修改
        submitDetailsData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    if (this.type == 1) {
                        this.submitEditData(); //修改
                    } else {
                        this.submitAddData(); //新增
                    }
                } else {
                    return false;
                }
            });
        },
        //提交产品批文 信息修改
        submitEditData() {
            let params = {
                rid: this.rid,
                code: this.ruleForm.code,
                licence_number: this.ruleForm.licence_number ? this.ruleForm.licence_number : '',
                product_common_name: this.ruleForm.product_common_name,
                content_spec: this.ruleForm.content_spec,
                content_un: this.ruleForm.content_un,
                dosage_un: this.ruleForm.dosage_un ? this.ruleForm.dosage_un : '',
                product_therapeutic_area_rids: this.ruleForm.product_therapeutic_area_rids ? this.ruleForm.product_therapeutic_area_rids : '',
                product_formulation: this.ruleForm.product_formulation ? this.ruleForm.product_formulation : '',
                validity_months: this.ruleForm.validity_months ? this.ruleForm.validity_months : '0',
                validity_days: this.ruleForm.validity_days ? this.ruleForm.validity_days : '0',
                manufacturer_rid: this.ruleForm.manufacturer_rid ? this.ruleForm.manufacturer_rid : ''
            };
            this.$api
                .productLicenceUpdate(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                    
                });
        },
        //新增产品批文
        submitAddData() {
            let params = {
                code: this.ruleForm.code,
                licence_number: this.ruleForm.licence_number ? this.ruleForm.licence_number : '',
                product_common_name: this.ruleForm.product_common_name,
                content_spec: this.ruleForm.content_spec,
                content_un: this.ruleForm.content_un,
                dosage_un: this.ruleForm.dosage_un ? this.ruleForm.dosage_un : '',
                // 待优化，映射出治疗领域
                product_therapeutic_area_rids: this.ruleForm.product_therapeutic_area_rids ? this.ruleForm.product_therapeutic_area_rids : '',
                product_formulation: this.ruleForm.product_formulation ? this.ruleForm.product_formulation : '',
                validity_months: this.ruleForm.validity_months ? this.ruleForm.validity_months : '0',
                validity_days: this.ruleForm.validity_days ? this.ruleForm.validity_days : '0',
                manufacturer_rid: this.ruleForm.manufacturer_rid ? this.ruleForm.manufacturer_rid : ''
            };
            this.$api
                .productLicenceInsert(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '新增成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                    
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>